import { ErrorHandler, Injector, Injectable, inject } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ApplicationInsightsErrorHandler implements ErrorHandler{
    private injector = inject(Injector);


    handleError(error: any): void {
        const appInsightsService = this.injector.get(ApplicationInsightsService);
        if (appInsightsService) {
            appInsightsService.logException(error);
        }
        console.error(error);
    }
}
